import { Styles } from "@mcleod/core";

// Loaded via DynamicLoader magic
export const AppPanelStyles = Styles.make("pnl", () => {
    return {
        rowFillHeight: {
            flex: "1",
            overflow: "auto", // Changed from "hidden" to "auto" to enable scrolling
            alignItems: "unset",
            overflowX: "hidden", // Hide horizontal scrollbar
            WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
            scrollBehavior: "smooth",
            msOverflowStyle: "scrollbar" // Control scrollbar style in IE/Edge
        }
    };
});
